import { useContext, useState } from 'react';
import { Navigate } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material/styles';
import { Button, Card, CardActions, CardContent, CardHeader } from '@mui/material';
import { ApiUtils } from '@shared/api';
import { Input, RoutePaths } from '@shared';
import { RouterLink, SnackbarContext } from '@widgets';

const useStyles = makeStyles<Theme>((theme) => ({
  card: {
    padding: theme.spacing(0, 0.5, 2, 0.5),
  },
  cardActions: {
    justifyContent: 'space-between',
  },
  cardHeader: {
    background: 'none',
    textAlign: 'center',
    paddingTop: theme.spacing(3),
    paddingBottom: 0,
  },
  cardHeaderTitle: {
    color: theme.palette.primary.main,
  },
}));

export const ForgotPasswordPage = () => {
  const [emailAddress, setEmailAddress] = useState('');
  const [redirect, setRedirect] = useState(false);

  const snackbar = useContext(SnackbarContext);
  const classes = useStyles();

  async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    try {
      snackbar.open('Email has been sent');
      setRedirect(true);
    } catch (error) {
      snackbar.error(ApiUtils.getError(error));
    }
  }

  if (redirect) return <Navigate to={RoutePaths.login.onNavigate()} />;
  return (
    <Card className={classes.card}>
      <form onSubmit={onSubmit}>
        <CardHeader
          className={classes.cardHeader}
          title='Forgot Password'
          subheader='Use your email address to reset your password'
          classes={{ title: classes.cardHeaderTitle }}
        />
        <CardContent>
          <Input type='email' label='Email' name='emailAddress' required value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} />
        </CardContent>
        <CardActions className={classes.cardActions}>
          <Button type='button' size='small' component={RouterLink} to={RoutePaths.login.onNavigate()}>
            Back to Login
          </Button>
          <Button type='submit' size='small' color='primary' variant='contained'>
            Reset My Password
          </Button>
        </CardActions>
      </form>
    </Card>
  );
};
